import controller from './packet-card.controller';

export default {
  bindings: {
    packet: '<',
    discount: '<'
  },
  controller,
  // Girisli kartla ayni sablon: promokod gorunumu iki akista birebir ayni olmali.
  template: require('../../../components/packet-card/packet-card.html')
};



// WEBPACK FOOTER //
// src/app/no-auth/components/packet-card/packet-card.component.ts